import {
  Box,
  FormControl as MuiFormControl,
  Select,
  MenuItem,
  TextField,
  Typography,
  Button,
  Tooltip,
} from "@material-ui/core";
import { People as ContactIcon } from "@material-ui/icons";
import styled from "styled-components/macro";
import AdminVisibilityFilter from "../../../../components/AdminVisibilityFilter";

const FormControl = styled(MuiFormControl)`
  margin-left: ${({ theme }) => theme.spacing(2)}px;
`;

const BufferInputRow = ({ bufferName, onChange, values, disabled = false }) => {
  return (
    <Box my={4}>
      <TextField
        id={`${bufferName}-bufferAmount`}
        name="bufferAmount"
        size="small"
        onChange={(event) => onChange(event, bufferName)}
        value={values.bufferAmount}
        variant="outlined"
        disabled={disabled}
      />

      <FormControl size="small" variant="outlined" style={{ width: "88px" }}>
        <Select
          labelId={`${bufferName}-units-label`}
          id={`${bufferName}-units`}
          name="units"
          value={values.units}
          onChange={(event) => onChange(event, bufferName)}
          disabled={disabled}
        >
          <MenuItem value="miles">Miles</MenuItem>
          <MenuItem value="feet">Feet</MenuItem>
          <MenuItem value="acres">Acres</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

const SearchRadiusControl = ({
  bufferValues,
  onBufferValuesChange,
  onClearBuffers,
  onResetBuffers,
  reportMode,
  onReportModeToggle,
}) => {
  const handleClearBuffers = (event) => {
    event.preventDefault();
    onClearBuffers();
  };

  const handleReportModeToggle = () => {
    onReportModeToggle(!reportMode);
  };

  return (
    <Box p={1} mb={2}>
      {/*<Typography variant="body1">*/}
      {/*  This control can be used to create radius rings to easily identify if*/}
      {/*  features fall within a specified area. To use the tool, click anywhere*/}
      {/*  on the map.*/}
      {/*</Typography>*/}
      <Box my={2} width="100%">
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography variant="subtitle1">Buffers</Typography>
          <AdminVisibilityFilter>
            <Tooltip
              title={
                reportMode
                  ? "Exit Current Well Owner / Parcel Owner Report Mode"
                  : "Enable Current Well Owner / Parcel Owner Report"
              }
            >
              <Button
                size="small"
                variant={reportMode ? "contained" : "outlined"}
                color={reportMode ? "secondary" : "primary"}
                onClick={handleReportModeToggle}
                style={{ minWidth: "80px", padding: "4px 8px" }}
              >
                <ContactIcon style={{ fontSize: 16, marginRight: 4 }} />
                {reportMode ? "ON" : "OFF"}
              </Button>
            </Tooltip>
          </AdminVisibilityFilter>
        </Box>
        {reportMode && (
          <Box mb={2}>
            <Typography variant="caption" color="secondary">
              Current Well Owner / Parcel Owner Report Mode Active - Click on
              map to query wells in a given radius for current well owners and
              their respective parcel information
            </Typography>
          </Box>
        )}
        <form onSubmit={handleClearBuffers}>
          <Box>
            <BufferInputRow
              bufferName="buffer1"
              onChange={onBufferValuesChange}
              values={bufferValues.buffer1}
              disabled={false}
            />
            {!reportMode && (
              <>
                <BufferInputRow
                  bufferName="buffer2"
                  onChange={onBufferValuesChange}
                  values={bufferValues.buffer2}
                  disabled={reportMode}
                />
                <BufferInputRow
                  bufferName="buffer3"
                  onChange={onBufferValuesChange}
                  values={bufferValues.buffer3}
                  disabled={reportMode}
                />
                <BufferInputRow
                  bufferName="buffer4"
                  onChange={onBufferValuesChange}
                  values={bufferValues.buffer4}
                  disabled={reportMode}
                />
              </>
            )}
          </Box>
          <Box display="flex" gridColumnGap={8}>
            <Button type="submit" variant="contained">
              Clear Buffers
            </Button>
            <Button onClick={onResetBuffers} type="reset" variant="contained">
              Reset Form
            </Button>
          </Box>
        </form>
      </Box>
    </Box>
  );
};

export default SearchRadiusControl;
